import PropTypes from 'prop-types'
import styled from 'styled-components'

const propTypes = {
  hasActiveContract: PropTypes.bool,
  hasExpiredContract: PropTypes.bool,
  className: PropTypes.string,
  showToolTip: PropTypes.bool,
  size: PropTypes.string
}

const defaultProps = {
  hasActiveContract: false,
  hasExpiredContract: false,
  className: null,
  showToolTip: true,
  size: '18px'
}

const ServiceContractsIcon = ({ hasActiveContract, hasExpiredContract, size = '18px', className }) => {
  const activeIcon = hasActiveContract ? '/img/service_contract_active.png' : '/img/service_contract_none.png'
  const expiredIcon = hasExpiredContract ? '/img/service_contract_expired.png' : '/img/service_contract_none.png'
  const noneIcon = '/img/service_contract_none.png'

  const ContractIcon = () => {
    return hasActiveContract
      ? <S.ServiceContractIcon aria-label="active_service_contract" src={activeIcon} size={size} {...{ className }} />
      : hasExpiredContract
        ? <S.ServiceContractIcon aria-label="expired_service_contract" src={expiredIcon} size={size} {...{ className }} />
        : <S.ServiceContractIcon aria-label="no_service_contract" src={noneIcon} size={size} {...{ className }} />
  }

  return (
    <ContractIcon />
  )
}

ServiceContractsIcon.propTypes = propTypes
ServiceContractsIcon.defaultProps = defaultProps

export default ServiceContractsIcon

const S = {
  ServiceContractIcon: styled.img`
    cursor: pointer;
    max-width: 22px;
    align-self: flex-start;
  `
}
